export const name = 'siteDeviceInfoService' as const
export const VIEWER_SERVICE_PACKAGE_NAME = '@wix/site-service-device-info' as const
